<template>
    <div class="card">
        <div class="card card-custom" >
          <div class="card-header flex-wrap border-0 pt-6 pb-0">
            <div class="card-title">
              <h3 class="card-label">{{ $t('setting.twilio') }}</h3>
            </div>
          </div>
          <form @submit.prevent="submitForm" class="form">
            <div class="modal-content">
              <div class="modal-body">
                <RequiredText />
                <div class="row"> 
                   <Input
                      containerClass="col-12 col-md-6 mt-auto mb-10"
                      :name="`${id}-name`"
                      type="text"   
                      :label="$t('setting.twilio_name')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="true" size="lg"
                      :placeholder="$t('setting.twilio_name')"
                      v-model="formData.name"

                  />
                  <Input
                      containerClass="col-12 col-md-6 mt-auto mb-10"
                      :name="`${id}-twilio_account_sid`"
                      type="text"
                      :label="$t('setting.twilio_account_sid')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="true" size="lg"
                      :placeholder="$t('setting.twilio_account_sid')"
                      v-model="formData.credentials.id"
                  />
                  <Input
                      containerClass="col-12 col-md-6 mt-auto mb-10"
                      :name="`${id}-auth_token`"
                      type="text"
                      :label="$t('setting.twilio_auth_token')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="true" size="lg"
                      :placeholder="$t('setting.twilio_auth_token')"
                      v-model="formData.credentials.token"
                  />
                  <Input
                      containerClass="col-12 col-md-6 mt-auto mb-10"
                      :name="`${id}-from_number`"
                      type="text"   
                      :label="$t('setting.twilio_from_number')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="true" size="lg"
                      :placeholder="$t('setting.twilio_from_number')"
                      v-model="formData.credentials.from"
                  />
                 
                </div>
              </div>
              <div class="modal-footer">
                <Button v-if="$can(abilities.REMIND_CONFIG_CREATE)" btn-class="btn-sm me-3" type="new" id="submit_btn" btn-text="button.save" size="7px 30px" @click="createTwilio" :is-loading="processing"></Button>
              </div>
            </div>
          </form>
        </div>
      </div>
  </template>
  
<script setup>
  /* eslint-disable */
import {computed, onMounted, ref,watch} from "vue";
import Input from "@/components/Input.vue";
import RequiredText from "@/components/RequiredText"
import Button from "@/components/Button"
import i18n from '@/plugins/i18n';
import {useStore} from "vuex";
import abilities from "@/composables/abilities";

const store = useStore()
const processing = ref(false)
const formData = ref({
  id: null,
  name: '',
  credentials: {
    id: '',
    token: '',
    from: ''
  }
})
  
const twilio = computed(() => store.getters['twilio/getTwilioConfiguration'])

function loadTwilio(){
  store.dispatch('twilio/loadTwilio') 
};
  
function createTwilio() {
  processing.value = true
  store.dispatch('twilio/storeTwilio', formData.value) 
      .then(res => {
        window.toastr['success'](i18n.global.t("notification.config_success"))
        loadTwilio()
      })
      .catch(err => {
      })
      .finally(() => processing.value = false)
}

watch(() => twilio.value, (value) => {

  let twilioConfig = twilio.value[0];
  formData.value = {
    id: twilioConfig?.id || '',
    name: twilioConfig?.name || '',
    credentials: {
      id: twilioConfig?.credentials?.id,
      token: twilioConfig?.credentials?.token,
      from: twilioConfig?.credentials?.from,
    },         
  };
});

onMounted(() => {
  loadTwilio() 
})
</script>
  
  
  